import {
    NONPAYMENT_DETAILS_DATA_REQUEST,
    NONPAYMENT_DETAILS_DATA_SUCCESS,
    NONPAYMENT_DETAILS_DATA_FAILURE,
    NONPAYMENT_TOP_REASON_DATA_REQUEST,
    NONPAYMENT_TOP_REASON_DATA_SUCCESS,
    NONPAYMENT_TOP_REASON_DATA_FAILURE,
    NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_REQUEST,
    NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_SUCCESS,
    NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_FAILURE,
    NONPAYMENT_CLAIMS_TREND_LOB_DATA_REQUEST,
    NONPAYMENT_CLAIMS_TREND_LOB_DATA_SUCCESS,
    NONPAYMENT_CLAIMS_TREND_LOB_DATA_FAILURE,
    NONPAYMENT_COMPLETE_AND_TREND_DATA_REQUEST,
    NONPAYMENT_COMPLETE_AND_TREND_DATA_FAILURE,
    NONPAYMENT_COMPLETE_AND_TREND_DATA_SUCCESS,
    NONPAYMENT_SUBCATEGORY_REQUEST,
    NONPAYMENT_SUBCATEGORY_SUCCESS,
    NONPAYMENT_SUBCATEGORY_FAILURE,
    NONPAYMENT_SUBCATEGORY_LOADING,
} from '../../../actions/actionTypes';

interface NonPaymentReducerState {
    nonPaymentDetails: any;
    npDetailsIsLoading: boolean;
    npDetailsError: string | null;
    topReasonsData: any;
    topReasonIsLoading: boolean;
    topReasonError: string | null;
    claimsTrendGraphData?: any;
    claimsTrendGraphIsLoading?: boolean;
    claimsTrendGraphError?: string | null;
    claimsTrendLobData?: any;
    claimsTrendLobIsLoading?: boolean;
    claimsTrendLobError?: string | null;
    completeAndPartialTrendData?: any;
    completeAndPartialTrendIsLoading?: boolean,
    completeAndPartialTrendError: string | null;
    // Per-category subcategory data: { [categoryName]: { data, loading, error } }
    subCategoryData: { [categoryName: string]: { data: any; loading: boolean; error: any } };
}

const initialState: NonPaymentReducerState = {
    nonPaymentDetails: {},
    npDetailsIsLoading: false,
    npDetailsError: null,
    topReasonsData: {},
    topReasonIsLoading: false,
    topReasonError: null,
    claimsTrendGraphData: {},
    claimsTrendGraphIsLoading: false,
    claimsTrendGraphError: null,
    claimsTrendLobData: {},
    claimsTrendLobIsLoading: false,
    claimsTrendLobError: null,
    completeAndPartialTrendData: {},
    completeAndPartialTrendIsLoading: false,
    completeAndPartialTrendError: null,
    subCategoryData: {},
};

 const NonPaymentReducer = (
    state = initialState,
    action: { type: string; payload?: any }
  ): NonPaymentReducerState => {
    switch (action.type) {
      case NONPAYMENT_DETAILS_DATA_REQUEST:
        return {
          ...state,
          npDetailsIsLoading: true,
        };
  
      case NONPAYMENT_DETAILS_DATA_SUCCESS:
        return {
          ...state,
          nonPaymentDetails: action.payload,
          npDetailsIsLoading: false,
        };

      case NONPAYMENT_DETAILS_DATA_FAILURE:
        return {
          ...state,
          npDetailsError: action.payload,
          npDetailsIsLoading: false,
        };
        
      case NONPAYMENT_TOP_REASON_DATA_REQUEST:
        return {
          ...state,
          topReasonIsLoading: true,
          subCategoryData: {},
        };
    
      case NONPAYMENT_TOP_REASON_DATA_SUCCESS:
        return {
          ...state,
          topReasonsData: action.payload,
          topReasonIsLoading: false,
        };

      case NONPAYMENT_TOP_REASON_DATA_FAILURE:
        return {
          ...state,
          topReasonError: action.payload,
          topReasonIsLoading: false,
        };  

      case NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_REQUEST:
        return {
          ...state,
          claimsTrendGraphIsLoading: true,
        };
    
      case NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_SUCCESS:
        return {
          ...state,
          claimsTrendGraphData: action.payload,
          claimsTrendGraphIsLoading: false,
        };

      case NONPAYMENT_CLAIMS_TREND_GRAPH_DATA_FAILURE:
        return {
          ...state,
          claimsTrendGraphError: action.payload,
          claimsTrendGraphIsLoading: false,
        };  
    
      case NONPAYMENT_CLAIMS_TREND_LOB_DATA_REQUEST:
        return {
          ...state,
          claimsTrendLobIsLoading: true,
        };
    
      case NONPAYMENT_CLAIMS_TREND_LOB_DATA_SUCCESS:
        return {
          ...state,
          claimsTrendLobData: action.payload,
          claimsTrendLobIsLoading: false,
        };

      case NONPAYMENT_CLAIMS_TREND_LOB_DATA_FAILURE:
        return {
          ...state,
          claimsTrendLobError: action.payload,
          claimsTrendLobIsLoading: false,
        };  

        case NONPAYMENT_COMPLETE_AND_TREND_DATA_REQUEST:
          return {
            ...state,
            completeAndPartialTrendIsLoading: true,
          };
      
        case NONPAYMENT_COMPLETE_AND_TREND_DATA_SUCCESS:
          return {
            ...state,
            completeAndPartialTrendData: action.payload,
            completeAndPartialTrendIsLoading: false,
          };
  
        case NONPAYMENT_COMPLETE_AND_TREND_DATA_FAILURE:
          return {
            ...state,
            completeAndPartialTrendError: action.payload,
            completeAndPartialTrendIsLoading: false,
          };    

      // On-demand subcategory cases
      case NONPAYMENT_SUBCATEGORY_LOADING:
        return {
          ...state,
          subCategoryData: {
            ...state.subCategoryData,
            [action.payload.categoryName]: {
              ...state.subCategoryData[action.payload.categoryName],
              loading: action.payload.loading,
            },
          },
        };

      case NONPAYMENT_SUBCATEGORY_REQUEST:
        return {
          ...state,
          subCategoryData: {
            ...state.subCategoryData,
            [action.payload.categoryName]: {
              data: state.subCategoryData[action.payload.categoryName]?.data || null,
              loading: true,
              error: null,
            },
          },
        };

      case NONPAYMENT_SUBCATEGORY_SUCCESS:
        return {
          ...state,
          subCategoryData: {
            ...state.subCategoryData,
            [action.payload.categoryName]: {
              data: action.payload.data,
              loading: false,
              error: null,
            },
          },
        };

      case NONPAYMENT_SUBCATEGORY_FAILURE:
        return {
          ...state,
          subCategoryData: {
            ...state.subCategoryData,
            [action.payload.categoryName]: {
              data: null,
              loading: false,
              error: action.payload.error,
            },
          },
        };

      default:
        return state;
    }
  };

export default NonPaymentReducer;